/* Truck checkout button: when the checkout button is pressed, the truck backs in, the box goes
   inside, the doors close and the truck drives off; only then does checkout open, and until it
   appears the button says "Opening checkout". Checkout starts loading in the background as soon
   as the button is pressed. Shoppers who turn off motion, and any error, go straight to checkout. Settings: Theme settings > Truck
   checkout button (speed, easing, seconds per step, colours). */
(() => {
  if (window.__nordriTruck) return;
  window.__nordriTruck = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Positions in the XD's 303 x 72 button; map() stretches them to the real button. */
  const REST = { truckX: 286, boxX: -21.4, roadX: 276, door: 0, roadOp: 0, boxOp: 1 };
  const STEPS = [
    { to: { truckX: 96, boxX: 38.6, roadOp: 1 } },
    { to: { boxX: 78.6, door: 1 } },
    { to: { boxX: 118.6 } },
    { to: { door: 0 } },
    { set: { boxOp: 0 }, to: { truckX: 156, roadX: 306 } },
    { to: { truckX: 26, roadX: 1 } },
    { to: { truckX: 286, roadX: -417 } },
  ];

  function bezier(p1x, p1y, p2x, p2y) {
    const cx = 3 * p1x, bx = 3 * (p2x - p1x) - cx, ax = 1 - cx - bx;
    const cy = 3 * p1y, by = 3 * (p2y - p1y) - cy, ay = 1 - cy - by;
    const sx = (t) => ((ax * t + bx) * t + cx) * t;
    const sy = (t) => ((ay * t + by) * t + cy) * t;
    const dx = (t) => (3 * ax * t + 2 * bx) * t + cx;
    return (x) => {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      let t = x;
      for (let i = 0; i < 8; i++) {
        const e = sx(t) - x, d = dx(t);
        if (Math.abs(e) < 1e-5 || !d) break;
        t -= e / d;
      }
      return sy(Math.min(1, Math.max(0, t)));
    };
  }

  function checkout(btn) {
    const form = btn.form || document.getElementById(btn.getAttribute('form'));
    if (form && form.requestSubmit) form.requestSubmit(btn);
    else if (form) {
      const i = document.createElement('input');
      i.type = 'hidden'; i.name = 'checkout'; i.value = '1';
      form.appendChild(i); form.submit();
    } else window.location.href = '/checkout';
  }

  /* Start loading checkout the moment the button is pressed, so it is ready when the truck has
     gone: Chrome and Edge build the whole page in the background (prerender); other browsers
     fetch it ahead (prefetch). */
  function warmCheckout() {
    if (document.querySelector('[data-ntb-warm]')) return;
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      const s = document.createElement('script');
      s.type = 'speculationrules';
      s.dataset.ntbWarm = '';
      s.textContent = JSON.stringify({ prerender: [{ source: 'list', urls: ['/checkout'], eagerness: 'immediate' }] });
      document.head.appendChild(s);
    }
    const l = document.createElement('link');
    l.rel = 'prefetch'; l.href = '/checkout'; l.dataset.ntbWarm = '';
    document.head.appendChild(l);
  }

  /* Once the truck has gone the button says so, so it is never empty while checkout opens.
     The words show at once (no fade) and checkout only opens after the phone has drawn them:
     phones load the warmed-up checkout so fast that they used to leave before the words appeared.
     The dots are three real dots that fade in turn (Safari cannot animate dots made by CSS text). */
  function openCheckout(btn) {
    const text = btn.querySelector('.button-text');
    if (text) {
      if (!btn.dataset.truckText) btn.dataset.truckText = text.textContent;
      text.style.transition = 'none';
      text.textContent = btn.dataset.truckWait || 'Opening checkout';
      const dots = document.createElement('span');
      dots.className = 'ntb-dots';
      dots.innerHTML = '<i>.</i><i>.</i><i>.</i>';
      text.appendChild(dots);
      text.style.opacity = '1';
    }
    btn.classList.remove('is-truck');
    btn.classList.add('is-going');
    let left = false;
    const leave = () => {
      if (left) return;
      left = true;
      window.location.assign('/checkout');
    };
    requestAnimationFrame(() => requestAnimationFrame(() => setTimeout(leave, 350)));
    setTimeout(leave, 800); // in case the phone holds back drawing
  }

  function play(btn) {
    const svg = btn.querySelector('.ntb');
    const r = btn.getBoundingClientRect();
    if (!svg || !r.width || !r.height) return openCheckout(btn);

    const W = 72 * (r.width / r.height), k = W / 303;
    svg.setAttribute('viewBox', `0 0 ${W} 72`);
    const map = (o) => {
      const m = { ...o };
      if ('truckX' in o) m.truckX = o.truckX >= 286 ? W - 17 : o.truckX * k;
      if ('boxX' in o) m.boxX = o.boxX === 78.6 ? 96 * k - 17.4 : o.boxX === 118.6 ? 96 * k + 22.6 : o.boxX < 0 ? o.boxX : o.boxX * k;
      if ('roadX' in o) m.roadX = o.roadX === 276 ? W - 27 : o.roadX === 306 ? W + 3 : o.roadX < -100 ? -760 : o.roadX;
      return m;
    };
    const el = {
      truck: svg.querySelector('.ntb-truck'), box: svg.querySelector('.ntb-box'), road: svg.querySelector('.ntb-road'),
      doorT: svg.querySelector('.ntb-door-t'), doorB: svg.querySelector('.ntb-door-b'),
    };
    let st = map({ ...REST });
    const render = () => {
      el.truck.setAttribute('transform', `translate(${st.truckX} 12.3)`);
      el.box.setAttribute('transform', `translate(${st.boxX} 26.3)`);
      el.road.setAttribute('transform', `translate(${st.roadX} 0)`);
      el.road.setAttribute('opacity', st.roadOp);
      el.box.setAttribute('opacity', st.boxOp);
      const d = st.door;
      el.doorT.setAttribute('transform', `translate(${18.5 + 1.5 * d} ${3.2 - 0.5 * d}) rotate(${90 * d})`);
      el.doorB.setAttribute('transform', `translate(${19.5 + 0.5 * d} ${43.2 - 0.5 * d}) rotate(${-180 - 90 * d})`);
    };

    const speed = parseFloat(btn.dataset.truckSpeed) || 3;
    const ease = bezier(...(btn.dataset.truckEase || '0,0,.58,1').split(',').map(Number));
    const secs = (btn.dataset.truckSteps || '').split(',').map(parseFloat);
    const durs = STEPS.map((_, i) => Math.max(0.02, (secs[i] > 0 ? secs[i] : 0.5) / speed));
    const total = durs.reduce((a, b) => a + b, 0);

    btn.dataset.truckPlaying = '1';
    const text = btn.querySelector('.button-text');
    if (text) text.style.transitionDuration = `${durs[0]}s`;
    render();
    btn.classList.add('is-truck');
    warmCheckout();

    // Whatever happens, checkout opens: a back-up timer a little after the animation should end.
    let opened = false;
    const go = () => {
      if (opened) return;
      opened = true;
      openCheckout(btn);
    };
    const backup = setTimeout(go, (total + 1.5) * 1000);

    let i = 0, from = { ...st }, t0 = performance.now();
    if (STEPS[0].set) Object.assign(st, map({ ...STEPS[0].set }));
    const frame = (now) => {
      try {
        const p = Math.min(1, (now - t0) / 1000 / durs[i]);
        const to = map({ ...STEPS[i].to });
        const e = ease(p);
        for (const key in to) st[key] = from[key] + (to[key] - from[key]) * e;
        render();
        if (p >= 1) {
          i++;
          if (i >= STEPS.length) {
            clearTimeout(backup);
            go();
            return;
          }
          if (STEPS[i].set) Object.assign(st, map({ ...STEPS[i].set }));
          from = { ...st };
          t0 = now;
        }
        requestAnimationFrame(frame);
      } catch (err) {
        clearTimeout(backup);
        go();
      }
    };
    requestAnimationFrame(frame);
  }

  /* The button is a submit button in the HTML, so checkout still works if this script never
     loads. Once it has loaded, every truck button becomes a plain button, so neither the browser
     nor another script can send the cart to checkout before the truck has gone. The cart drawer
     is drawn again after every change, so new buttons are caught as they appear. */
  const SEL = 'button.nordri-truck[type="submit"]';
  const armOne = (b) => {
    b.type = 'button';
  };
  const arm = (el) => {
    if (el.matches(SEL)) armOne(el);
    el.querySelectorAll(SEL).forEach(armOne);
  };
  arm(document.documentElement);
  new MutationObserver((records) => {
    for (const r of records) {
      if (r.type === 'attributes') {
        if (r.target.matches(SEL)) armOne(r.target);
      } else {
        for (const n of r.addedNodes) if (n.nodeType === 1) arm(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['type'] });

  window.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest && e.target.closest('button.nordri-truck');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.dataset.truckPlaying) return;
      if (reduce.matches) return openCheckout(btn);
      try {
        play(btn);
      } catch (err) {
        openCheckout(btn);
      }
    },
    true
  );

  // Coming back with the browser's Back button: show the plain button again.
  // Safari brings the page back exactly as it was left, cart drawer still open, but draws it
  // pushed down under the status bar with the page showing above it. So the drawer is closed and
  // the page comes back clean.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      const drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.querySelector('dialog[open]') && typeof drawer.close === 'function') drawer.close();
    }
    document.querySelectorAll('button.nordri-truck').forEach((b) => {
      b.classList.remove('is-truck', 'is-going');
      delete b.dataset.truckPlaying;
      const text = b.querySelector('.button-text');
      if (text && b.dataset.truckText) text.textContent = b.dataset.truckText;
      if (text) text.style.opacity = text.style.transition = '';
    });
  });
})();
